import React from 'react';
import { IRouter } from '@routers/interface';
import { UserOutlined } from '@ant-design/icons';
import { PERMISSION_USERS } from '@modules/user/constants';

export const routerUsers: IRouter = {
  path: '/users',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'users.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  menu: {
    icon: <UserOutlined />,
  },
  permissionCode: PERMISSION_USERS.VIEW,
};
